module.exports = __webpack_public_path__ + "static/media/glasses.37c630fa.jpg";